import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import Loading from '../../../../facturotopia/loading/Loading';
import DetallesDelServicioManager from './plataformastecnologicas/DetallesDelServicioManager.jsx';
import RetencionesCatalogoManager from '../../../catalogs/managers/RetencionesCatalogoManager.jsx';
import PlataformasTecnologicasForm from './plataformastecnologicas/PlataformasTecnologicasForm.jsx';

const initialSteps = {
  base: false,
};

const initialFormValidation = {
  isValidBase: false,
  isValidServicios: false,
};

const ComplementoPlataformasTecnologicas = (props) => {
  const [data, setData] = useState({});
  const [steps, setSteps] = useState(initialSteps);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [bootCatalog, setBootCatalog] = useState(false);

  useEffect(() => {
    loadCatalog();
  }, []);

  useEffect(() => {
    if (props.data) {
      setData({ ...props.data });
      setSteps({
        base: true,
      });
      setFormValidation({
        isValidBase: true,
        isValidServicios: true,
      });
    }

    return () => {};
  }, [props.data]);

  const loadCatalog = async () => {
    try {
      await RetencionesCatalogoManager.boot();

      setBootCatalog(true);
    } catch (error) {}
  };

  const handleOnChange = (event, metadata) => {
    const newData = {
      Version: '1.0',
      ...data,
      ...event,
    };

    if (metadata.step) {
      setSteps({
        ...steps,
        [metadata.step]: metadata.isValid,
      });
    }

    setFormValidation({
      ...formValidation,
      [metadata.name]: metadata.isValid,
    });

    setData(newData);
  };

  const handleOnComplementoAdd = () => {
    const ServiciosPlataformasTecnologicas = data;

    props.onChange({ ServiciosPlataformasTecnologicas });

    clearData();
  };

  const handleOutForm = () => {
    props.onCancel();
  };

  const clearData = () => {
    setData({});
  };

  const isValidAllForms = () => {
    let isValid = false;

    for (const key in formValidation) {
      if (Object.prototype.hasOwnProperty.call(formValidation, key)) {
        if (formValidation[key] === false) {
          isValid = false;
          break;
        }

        isValid = formValidation[key] ?? false;
      }
    }

    return isValid;
  };

  if (!bootCatalog) {
    return <Loading />;
  }

  return (
    <>
      <Row>
        <Col>
          <h5 className="text-right">Plataformas Tecnológicas</h5>
        </Col>
      </Row>

      <PlataformasTecnologicasForm
        data={data}
        onFormDataChange={handleOnChange}
      />

      {steps.base && (
        <DetallesDelServicioManager
          data={data}
          onFormDataChange={handleOnChange}
        />
      )}

      <Row>
        <Col>
          <Button
            variant="secondary"
            className="mr-2"
            onClick={handleOutForm}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            disabled={!isValidAllForms()}
            onClick={handleOnComplementoAdd}
          >
            Agregar complemento
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ComplementoPlataformasTecnologicas;
